import {
  useMutation,
  useQueryClient,
  UseMutationResult,
  UseMutationOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type { ResponseDto, MFADisableResponseDto } from "@mimber/schema"
import { accountKeys, securityEventsKeys } from "../account.utils"

export const useMFADisable = (
  options?: UseMutationOptions<ResponseDto<MFADisableResponseDto>, Error, void>
): UseMutationResult<ResponseDto<MFADisableResponseDto>, Error, void> => {
  guardAppUsage("mimber-organization", "useMFADisable")

  const { server } = useServerContext()
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: async () => {
      const response = await server.post<ResponseDto<MFADisableResponseDto>>(
        "account/mfa/disable"
      )
      return response.data
    },
    onSuccess: (response, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({
        queryKey: accountKeys.getStatus(),
      })
      queryClient.invalidateQueries({
        queryKey: securityEventsKeys.findAll(),
      })
      options?.onSuccess?.(response, variables, onMutateResult, context)
    },
  })
}
